import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const DirectoryPagination = ({ result, offset, limit, switchPage, filterOpen }) => {
  const { data } = result || {};

  return (
    <React.Fragment>
      <span />
      <span className="hidden">{`Results: ${data && data?.product?.length}`}</span>

      {!filterOpen && (
        <div className="pagination">
          <button
            type="button"
            onClick={() => switchPage('prev')}
            className={offset === 0 ? 'disabled' : ''}
            disabled={offset === 0}
          >
            <FontAwesomeIcon icon={['fas', 'caret-left']} />
          </button>
          <button
            type="button"
            onClick={() => switchPage('next')}
            className={data?.product?.length < limit ? 'disabled' : ''}
            disabled={data?.product?.length < limit}
          >
            <FontAwesomeIcon icon={['fas', 'caret-right']} />
          </button>
        </div>
      )}
    </React.Fragment>
  );
};

export default DirectoryPagination;

DirectoryPagination.propTypes = {
  offset: PropTypes.number.isRequired,
  limit: PropTypes.number.isRequired,
  switchPage: PropTypes.func.isRequired,
  filterOpen: PropTypes.bool,
  result: PropTypes.shape({
    data: PropTypes.shape(),
    loading: PropTypes.bool,
  }),
};

DirectoryPagination.defaultProps = {
  filterOpen: false,
  result: {
    data: {},
    loading: true,
  },
};
